import React from 'react';
import { Spin, Typography, Space } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const { Text } = Typography;

const AppLoading = ({ message = 'Loading...' }) => {
  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 32,
        color: '#f97316',
      }}
      spin
    />
  );

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'linear-gradient(135deg, #f0f0f0 0%, #e5e5e5 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      {/* Logo Section */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: '32px',
          animation: 'fadeInDown 0.8s ease-out',
        }}
      >
        <img
          src="/logo128.png"
          alt="YUP ORDER Logo"
          style={{
            width: '48px',
            height: '48px',
            marginRight: '12px',
            filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1))',
          }}
        />
        <h1
          style={{
            color: '#f97316',
            margin: 0,
            fontSize: '28px',
            fontWeight: 'bold',
            letterSpacing: '0.5px',
            background: 'linear-gradient(135deg, #f97316 0%, #ea580c 50%, #f97316 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          YUP ORDER
        </h1>
      </div>

      {/* Loading Spinner */}
      <div
        style={{
          animation: 'pulse 2s ease-in-out infinite',
        }}
      >
        <Spin
          indicator={antIcon}
          size="large"
        />
      </div>

      {/* Loading Message */}
      <Space
        direction="vertical"
        align="center"
        style={{
          marginTop: '24px',
          animation: 'fadeInUp 1s ease-out 0.3s both',
        }}
      >
        <Text
          style={{
            fontSize: '16px',
            color: '#666',
            fontWeight: '500',
            textAlign: 'center',
          }}
        >
          {message}
        </Text>
        <Text
          type="secondary"
          style={{
            fontSize: '12px',
            color: '#999',
            textAlign: 'center',
          }}
        >
          Initializing your workspace...
        </Text>
      </Space>

      {/* Loading dots animation */}
      <div
        style={{
          display: 'flex',
          gap: '8px',
          marginTop: '20px',
          animation: 'fadeInUp 1s ease-out 0.6s both',
        }}
      >
        {[0, 1, 2].map((index) => (
          <div
            key={index}
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: '#f97316',
              animation: `loadingDots 1.4s ease-in-out ${index * 0.16}s infinite both`,
            }}
          />
        ))}
      </div>

      {/* Inline CSS animations */}
      <style jsx>{`
        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
        }

        @keyframes loadingDots {
          0%, 80%, 100% {
            transform: scale(0.8);
            opacity: 0.5;
          }
          40% {
            transform: scale(1.2);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default AppLoading;
